'use client';

import React from 'react';
import { BarChart2, TrendingUp, Tv, BookOpen, Globe } from 'lucide-react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';


const footerFeatures = [
  {
    id: 'ff-realtime',
    icon: BarChart2,
    label: 'Real-Time Data',
    desc: 'Live prices & market updates',
  },
  {
    id: 'ff-expert',
    icon: TrendingUp,
    label: 'Expert Analysis',
    desc: 'In-depth market insights',
  },
  {
    id: 'ff-live',
    icon: Tv,
    label: 'Live TV 24/7',
    desc: 'News that moves markets',
    live: true,
  },
  {
    id: 'ff-edu',
    icon: BookOpen,
    label: 'Educational Content',
    desc: 'Learn & grow your knowledge',
  },
  {
    id: 'ff-coverage',
    icon: Globe,
    label: '24/7 Coverage',
    desc: 'Always on, always updated',
  },
];

const footerLinks = [
  { label: 'Blog', href: '/blog' },
  { label: 'Privacy Policy', href: '/privacy' },
  { label: 'Terms of Service', href: '/terms' },
  { label: 'Cookie Policy', href: '/cookies' },
  { label: 'Contact Us', href: '/contact' },
];

export default function FooterBar() {
  return (
    <footer className="w-full border-t border-border bg-card mt-4">
      <div className="w-full max-w-screen-2xl mx-auto px-4 lg:px-6 xl:px-8 2xl:px-10">
        {/* Feature Strip */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-px bg-border">
          {footerFeatures?.map((f) => {
            const Icon = f?.icon;
            return (
              <div
                key={f?.id}
                className="flex items-center gap-3 px-4 py-4 bg-card hover:bg-muted/30 transition-colors duration-150"
              >
                <Icon size={20} className="text-muted-foreground flex-shrink-0" />
                <div>
                  <div className="flex items-center gap-1.5">
                    <span className="text-xs font-semibold text-foreground">{f?.label}</span>
                    {f?.live && (
                      <span className="bg-primary text-white text-[8px] font-bold px-1 py-0.5 rounded uppercase tracking-wider live-pulse">
                        LIVE
                      </span>
                    )}
                  </div>
                  <p className="text-[10px] text-muted-foreground">{f?.desc}</p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 py-4 text-[11px] text-muted-foreground">
          <div className="flex items-center gap-3">
            <img
              src="/assets/images/DMTV_Official_Logo-1789695605720.png"
              alt="DMTV Digital Money TV"
              className="h-7 w-auto object-contain"
            />
            <p>© 2026 DMTV Digital Money TV. All rights reserved.</p>
          </div>
          <div className="flex items-center gap-4">
            {footerLinks?.map((item) => (
              <Link
                key={`footer-link-${item?.label}`}
                href={item?.href}
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="hover:text-foreground transition-colors duration-150 cursor-pointer"
              >
                {item?.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}